export default __webpack_public_path__ + "static/media/secured_drapery.007217b3.png";